// extracted by mini-css-extract-plugin
export default {"editor":"commentEditor_editor__yNp5U","buttonWrapper":"commentEditor_buttonWrapper__MX0ao"};